import { render, staticRenderFns } from "./updUser.vue?vue&type=template&id=34c238a2&scoped=true"
import script from "./updUser.vue?vue&type=script&lang=js"
export * from "./updUser.vue?vue&type=script&lang=js"
import style0 from "./updUser.vue?vue&type=style&index=0&id=34c238a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c238a2",
  null
  
)

export default component.exports